import React, { useContext, useEffect, useState } from 'react';
import { SMHeader, StaticContext } from '@sm/webassets';
import AppDirNavHeader from '../AppDirNavHeader';

const ModernHeader = () => {
  const {
    environment: { languageCode: language },
    user,
    locale: { isEUDC },
  } = useContext(StaticContext);

  // Render the header post SSR as it is breaking SSR
  const [renderHeader, setRenderHeader] = useState(false);

  useEffect(() => {
    setRenderHeader(true);
  }, [setRenderHeader]);

  return (
    <>
      <If condition={renderHeader}>
        <If condition={user.isAuthenticated}>
          <SMHeader
            lang={language}
            isEUDC={isEUDC}
            user={user}
            isUserAuthenticated={user.isAuthenticated}
            wrenchVariant="apps"
          />
        </If>
        <If condition={!user.isAuthenticated}>
          <AppDirNavHeader />
        </If>
      </If>
    </>
  );
};

export default ModernHeader;
